import {
  isAeProduct,
  isChatppProduct,
  isMasterOnline,
  isSiteGiant,
  isTfsoftware,
} from 'productLine';

// 店铺授权即将失效提醒优化
export const AuthBeAboutToExpireFeature = !isAeProduct;

// 待办模块功能
export const ToDosFeature = isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 配置接待评分任务
export const ReceptionRatingConfigFeature =
  isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 配置暂停自动回复
export const PauseAutoReplyConfigFeature =
  isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 绩效报告功能
export const PerfReportFeature = isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 数据看板-平台选择器
export const DashboardPlatformSelectorFeature =
  isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 数据看板-店铺选择器
export const DashboardStoreSelectorFeature =
  isChatppProduct || isTfsoftware || isMasterOnline || isSiteGiant;

// 运营助理入口
export const KnowledgeEntryFeature =
  isChatppProduct || isTfsoftware || isAeProduct || isMasterOnline || isSiteGiant;

// 质检
export const QIFeature = import.meta.env.VITE_QI === 'true';
